import { ActionKeys } from './constants';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const changeQueryString = (queryStringParams: Record<string, any>) =>
  <const>{
    payload: {
      ...queryStringParams,
    },
    type: ActionKeys.CHANGE_QUERY_PARAMS,
  };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateQueryParam = (name: string, value: any) =>
  <const>{
    payload: {
      name,
      value,
    },
    type: ActionKeys.UPDATE_QUERY_PARAM,
  };

export const storeCurrentQueryParams = () =>
  <const>{
    type: ActionKeys.STORE_CURRENT_QUERY_PARAMS,
  };

export const restoreQueryParams = () =>
  <const>{
    type: ActionKeys.RESTORE_QUERY_PARAMS,
  };
